<template>
  <div class="comment-section">
    <!-- 评论区标题 -->
    <div class="comment-header">
      <div class="header-content">
        <div class="icon-wrapper">
          <svg
            class="comment-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        </div>
        <div class="header-text">
          <h2 class="title">评论交流</h2>
          <p class="subtitle">Share your thoughts</p>
        </div>
      </div>
      <div class="comment-count">
        <span class="count-number">12</span>
        <span class="count-label">条评论</span>
      </div>
    </div>

    <!-- 装饰分割线 -->
    <div class="divider-wrapper">
      <div class="divider-line"></div>
      <div class="divider-dot"></div>
    </div>

    <!-- 本地开发模拟评论 -->
    <div class="mock-comments">
      <!-- 提示信息 -->
      <div class="dev-notice">
        <svg class="notice-icon" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"
          />
        </svg>
        <div>
          <p class="notice-title">开发模式</p>
          <p class="notice-text">
            评论功能将在生产环境中启用（配置后自动切换）
          </p>
        </div>
      </div>

      <!-- 模拟评论输入框 -->
      <div class="mock-input-area">
        <div class="input-header">
          <div class="user-avatar">
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="input-placeholder">
            <p>分享你的想法...</p>
            <span class="input-hint">需要 GitHub 账号登录</span>
          </div>
        </div>
      </div>

      <!-- 模拟评论列表 -->
      <div class="mock-comment-list">
        <div
          v-for="(comment, index) in comments"
          :key="index"
          class="mock-comment-item"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="comment-avatar">
            <div
              class="avatar-circle"
              :style="{ background: comment.avatarColor }"
            >
              {{ comment.author.charAt(0) }}
            </div>
          </div>
          <div class="comment-content">
            <div class="comment-meta">
              <span class="comment-author">{{ comment.author }}</span>
              <span class="comment-badge">{{ comment.badge }}</span>
              <span class="comment-time">{{ comment.time }}</span>
            </div>
            <p class="comment-text">{{ comment.text }}</p>
            <div class="comment-actions">
              <button class="action-btn">
                <svg
                  class="action-icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                  />
                </svg>
                <span>{{ comment.likes }}</span>
              </button>
              <button class="action-btn">
                <svg
                  class="action-icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                  />
                </svg>
                <span>回复</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Giscus 容器（生产环境时通过 JS 动态加载） -->
    <div
      ref="giscusContainer"
      class="giscus-container"
      style="display: none"
    ></div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "CommentSection",
  props: {
    articleId: {
      type: String,
      required: true,
    },
    repo: {
      type: String,
      default: "your-username/your-repo",
    },
    repoId: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "Announcements",
    },
    categoryId: {
      type: String,
      default: "",
    },
    mapping: {
      type: String,
      default: "pathname",
    },
    theme: {
      type: String,
      default: "light",
    },
    lang: {
      type: String,
      default: "zh-CN",
    },
  },
  setup(props) {
    const giscusContainer = ref(null);

    const comments = ref([
      {
        author: "张小明",
        badge: "活跃读者",
        time: "2小时前",
        text: "这篇文章写得太好了！特别是关于技术栈选择的部分，给了我很多启发。期待更多这样的深度内容 🎉",
        likes: 24,
        avatarColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      },
      {
        author: "TechExplorer",
        badge: "技术爱好者",
        time: "5小时前",
        text: "有个问题想请教：如果项目规模比较大，Serverless 方案会不会有性能瓶颈？",
        likes: 8,
        avatarColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      },
      {
        author: "李开发",
        badge: "前端工程师",
        time: "1天前",
        text: "正好在做类似的项目，这篇文章来得太及时了！已经收藏，准备按照这个思路重构一下 💪",
        likes: 15,
        avatarColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      },
    ]);

    onMounted(() => {
      // 生产环境检测：如果配置了有效的 repo 和 repoId，则加载 Giscus
      const isConfigured =
        props.repo !== "your-username/your-repo" && props.repoId;
      const isProduction =
        window.location.hostname !== "localhost" &&
        window.location.hostname !== "127.0.0.1";

      if (isConfigured && isProduction) {
        // 隐藏模拟评论，显示 Giscus
        const mockComments = document.querySelector(".mock-comments");
        if (mockComments) mockComments.style.display = "none";
        if (giscusContainer.value)
          giscusContainer.value.style.display = "block";

        // 加载 Giscus 脚本
        const script = document.createElement("script");
        script.src = "https://giscus.app/client.js";
        script.setAttribute("data-repo", props.repo);
        script.setAttribute("data-repo-id", props.repoId);
        script.setAttribute("data-category", props.category);
        script.setAttribute("data-category-id", props.categoryId);
        script.setAttribute("data-mapping", props.mapping);
        script.setAttribute("data-strict", "0");
        script.setAttribute("data-reactions-enabled", "1");
        script.setAttribute("data-emit-metadata", "0");
        script.setAttribute("data-input-position", "top");
        script.setAttribute("data-theme", props.theme);
        script.setAttribute("data-lang", props.lang);
        script.setAttribute("data-loading", "lazy");
        script.crossOrigin = "anonymous";
        script.async = true;

        giscusContainer.value.appendChild(script);
      }
    });

    return {
      giscusContainer,
      comments,
    };
  },
};
</script>

<style scoped>
.comment-section {
  margin-top: 0;
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

/* 评论区标题 */
.comment-header {
  position: relative;
  padding: 2rem 2.5rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comment-header::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  background-size: 200% 200%;
  animation: gradient-shift 8s ease infinite;
  z-index: 0;
}

.comment-header::after {
  content: "";
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAgTSAwIDIwIEwgNDAgMjAgTSAyMCAwIEwgMjAgNDAgTSAwIDMwIEwgNDAgMzAgTSAzMCAwIEwgMzAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC41IiBvcGFjaXR5PSIwLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=")
    repeat;
  opacity: 0.3;
  z-index: 0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  z-index: 1;
}

.icon-wrapper {
  width: 3.5rem;
  height: 3.5rem;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.comment-icon {
  width: 2rem;
  height: 2rem;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.header-text {
  color: white;
}

.title {
  font-size: 1.75rem;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle {
  font-size: 0.875rem;
  margin: 0.25rem 0 0;
  opacity: 0.95;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.comment-count {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  position: relative;
  z-index: 1;
}

.count-number {
  font-size: 2rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.count-label {
  font-size: 0.875rem;
  color: white;
  opacity: 0.9;
  font-weight: 600;
}

/* 装饰分割线 */
.divider-wrapper {
  position: relative;
  height: 3px;
  background: transparent;
}

.divider-line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 100%;
  background: linear-gradient(
    to right,
    transparent,
    #3b82f6,
    #8b5cf6,
    #ec4899,
    transparent
  );
  opacity: 0.6;
}

.divider-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 50%;
  box-shadow: 0 0 0 4px white, 0 0 0 6px rgba(59, 130, 246, 0.2);
}

/* Giscus 容器 */
.giscus-container {
  padding: 2.5rem;
  min-height: 200px;
}

/* 模拟评论区 */
.mock-comments {
  padding: 2.5rem;
}

.dev-notice {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%);
  border-radius: 12px;
  border: 2px solid #bfdbfe;
  margin-bottom: 2rem;
}

.notice-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #3b82f6;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.notice-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e40af;
  margin: 0 0 0.25rem;
}

.notice-text {
  font-size: 0.875rem;
  color: #475569;
  margin: 0;
}

/* 模拟输入框 */
.mock-input-area {
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  border: 2px dashed #d1d5db;
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  transition: all 0.3s ease;
}

.mock-input-area:hover {
  border-color: #9ca3af;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
}

.input-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-avatar {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, #d1d5db, #9ca3af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-avatar svg {
  width: 1.75rem;
  height: 1.75rem;
  color: white;
}

.input-placeholder p {
  font-size: 1rem;
  color: #6b7280;
  margin: 0 0 0.25rem;
  font-weight: 500;
}

.input-hint {
  font-size: 0.75rem;
  color: #9ca3af;
}

/* 模拟评论列表 */
.mock-comment-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.mock-comment-item {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.mock-comment-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
  border-color: #cbd5e1;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.comment-avatar {
  flex-shrink: 0;
}

.avatar-circle {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 3px solid white;
}

.comment-content {
  flex: 1;
  min-width: 0;
}

.comment-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.comment-author {
  font-weight: 700;
  color: #1f2937;
  font-size: 0.9375rem;
}

.comment-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);
  color: #3b82f6;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 9999px;
  border: 1px solid #bfdbfe;
}

.comment-time {
  font-size: 0.8125rem;
  color: #9ca3af;
}

.comment-text {
  color: #4b5563;
  line-height: 1.7;
  margin: 0 0 1rem;
  font-size: 0.9375rem;
}

.comment-actions {
  display: flex;
  gap: 1rem;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%);
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-1px);
}

.action-icon {
  width: 1rem;
  height: 1rem;
}

@keyframes gradient-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* 响应式 */
@media (max-width: 640px) {
  .comment-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.5rem;
  }

  .comment-count {
    align-self: flex-end;
  }

  .title {
    font-size: 1.5rem;
  }

  .mock-comments,
  .giscus-container {
    padding: 1.5rem;
  }

  .mock-comment-item {
    padding: 1rem;
  }

  .comment-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>
